import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import {Theme} from '../stores/AppStore';

export const Container = styled.span`
  display: inline-grid;
  box-sizing: border-box;
  padding: 2px 4px;
  border-radius: 5px;
  font-size: 12px;
  line-height: 16px;
  background: ${({theme}) => theme.name === Theme.Dark ? `
    ${transparentize(.85, theme.colors.white)};
  ` : transparentize(.85, theme.variables.color)};
`;

/**
 * The component render tag.
 * @param {React.PropsWithChildren<any>} props
 * @return {React.ReactElement<React.PropsWithChildren<any>>}
 * @constructor
 */
export default function Tag(
    props: React.PropsWithChildren<any>,
): React.ReactElement<React.PropsWithChildren<any>> {
  return (
    <Container>
      {props.children}
    </Container>
  );
}
